// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';

// Types
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

type Props = {
  value?: string | number;
  className?: string;
  onClick?: () => void;
  id?: string;
  disclaimer?: string;
  hasDisclaimer?: boolean;
  item?: ComparisonItem;
  locale?: Locale;
};

const TextCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, item, onClick, id, hasDisclaimer, locale }: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  if (value === '') {
    return <div className="cell no-data-cell">&nbsp;</div>; // Non-breaking space to ensure empty cells have a value and does not break table regularity in Acrobat
  }

  return (
    <div className={classNames('cell text-cell', className)} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <span className="markup-container">
        {value}
        {hasDisclaimer && '*'}
      </span>
    </div>
  );
};

export default TextCell;
